import * as helpers from '../helpers';

export default class SlideToggler {
    constructor(selector, options = null) {
        this.selector = selector;
        this.height = null;
        this.brokenImages = null;
        this.brokenImagesHeight = 0;
        this.duration = null;
        this.togglerState = null;
        this.options = {
            display: window.getComputedStyle(this.selector).display,
            duration: null,
            isWrapContent: false,
            toggleClassName: '-is-open',
            class: {
                wrapPrefix: '__slide-wrap',
            },
            initializedClass: '-is-initialized',
        };

        if (!(this.selector instanceof HTMLElement)) {
            return;
        }

        if (options instanceof Object) {
            this.options = helpers.extendDefaults(this.options, options);
        }

        this.init();
    }

    get state() {
        return this.togglerState;
    }

    init() {
        if (helpers.hasClass(this.selector, this.options.initializedClass)) {
            return;
        }
        helpers.addClass(this.selector, this.options.initializedClass);
        helpers.callIfTrue(this.options.isWrapContent, this.wrapContent.bind(this));
        this.updateValues(); // Get initial values
        this.togglerState = !!this.height;

        window.addEventListener('resize', helpers.debounce(this.updateValues.bind(this), 250)); // Update current values after window was resized
    }

    updateValues() {
        this.height = this.getHeight();
        this.duration = this.options.duration || Math.floor(this.height / 3) + 300;
    }

    getHeight() {
        const parent = this.selector.parentNode;
        const temp = document.createElement('div');
        temp.style.cssText = 'visibility: hidden; overflow: hidden; max-height: 0;';

        const clone = this.selector.cloneNode(true);
        clone.style.cssText = 'display: block;';

        temp.appendChild(clone);
        parent.appendChild(temp);

        const height = clone.clientHeight;
        parent.removeChild(temp);

        return height;
    }

    getDirection() {
        const currHeight = this.selector.clientHeight * (window.getComputedStyle(this.selector).display !== 'none'); // Return height but if is hidden return 0

        if (currHeight > ((this.height) / 2)) {
            return [this.height, 0];
        }
        return [0, this.height];
    }

    wrapContent() {
        const wrapClass = this.selector.classList[0].split('__')[0]; // Get first class in list and remove modifier if exists
        this.selector.innerHTML = `<div${(wrapClass ? ` class="${wrapClass + this.options.class.wrapPrefix}"` : '')}>${this.selector.innerHTML}</div>`;
    }

    open() {
        if (this.getDirection()[0] === 0) {
            if (this.height === 0) {
                this.updateValues();
            }

            this.toggle();
        } else {
            console.log('Already opened!');
        }
    }

    close() {
        if (this.getDirection()[0] !== 0) {
            if (this.height === 0) {
                this.updateValues();
            }

            this.toggle();
        } else {
            console.log('Already closed!');
        }
    }

    toggle() {
        const [start, end] = this.getDirection();
        const disp = end - start;
        const display = this.options.display && this.options.display !== 'none' ? this.options.display : 'block';
        const init = performance.now();

        // this.selector.classList[end === 0 ? 'remove' : 'add'](this.options.toggleClassName); // add optional class
        // helpers[end === 0 ? 'removeClass' : 'addClass'](this.selector, this.options.toggleClassName);
        this.togglerState = end === 0;
        this.selector.style.cssText = `overflow: hidden; display: ${display};`;

        const repeat = (time) => {
            let timePassed = time - init;
            const step = start + ((disp * timePassed) / this.duration);

            if (timePassed > this.duration) {
                timePassed = this.duration;
            }

            // Animate height
            this.selector.style.height = `${step}px`;

            if (timePassed < this.duration) {
                requestAnimationFrame(repeat);
            } else {
                this.selector.style.cssText = `display: ${end === 0 ? 'none' : display}`;
            }
        };

        return repeat(init);
    }
}
